module.exports = __webpack_public_path__ + "img/youtube-icon.1128b53a.svg";